<template>
  <div>
    <div class="collection-container" v-loading="loading">
      <ul>
        <li v-for="course in courseList" @click="todetail(course)" :key="`collect${course.id}`">
          <a href="javascript:;">
            <div class="collection-cover">
              <!-- <img v-lazy="course.image"> -->
               <el-image
                  style="width: 100%; height: 100%; borderRadius: 4px;position: absolute;"
                  :src="course.image"
                ></el-image>
              <span class="collection-cover-text">已学{{course.rate}}%</span>
            </div>
            <div class="collection-right">
              <div class="collection-title">{{course.name}}</div>
              <div class="collection-icon">
                  <div class="all-contentli-left"><img src="../../../assets/img/icon-eye.png"><span class="all-contentli-left-text">{{course.watch}}</span></div>
                  <div class="all-contentli-left">
                    <img v-show="course.isLike == 0" src="../../../assets/img/icon-heart.png">
                    <img v-show="course.isLike == 1" src="../../../assets/img/icon-heart1.png">
                    <span class="all-contentli-left-text">{{course.like}}</span>
                  </div>
                  <!-- <div class="all-contentli-left"><img src="../../../assets/img/icon-collection.png"><span class="all-contentli-left-text">{{course.like}}</span></div> -->
              </div>
            </div>
          </a>
        </li>
      </ul>
      <div class="task-pagination" style="text-align: center;" v-show="listlength">
        <el-pagination
              @current-change="handleCurrentChange"
              :current-page.sync="pageNum"
              :page-size="pageSize"
              layout="prev, pager, next, jumper"
              :total="total">
            </el-pagination>
      </div>
      <nothing v-show="!listlength"></nothing>
    </div>

  </div>
</template>

<script>
import {ApiMyCollect} from '../../../net/accound/index.js'
import {setCookie} from '../../../untils/common.js'
import nothing from '../../../common/nothing.vue'
  export default {
    data: function () {
      return {
        pageNum: 1,
        pageSize: 5,
        total: 0,
        loading: false,
        courseList: []
      }
    },
    components:{nothing},
    computed: {
      listlength: function () {
        return this.courseList.length
      },
    },
    methods: {
      getMyCollect: function () {
        const prames = {
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          platform: 'pc'
        }
        this.loading = true
        ApiMyCollect(prames).then(res=>{
          // console.log('res', res)
          this.courseList = res.pc.details
          this.total = res.pc.total
          this.loading = false
        })
      },
      handleCurrentChange: function (index) {
        this.pageNum = index
        this.getMyCollect()
      },
      todetail: function (item){
        setCookie('frompage','account');
        this.$router.push({
            path : 'CourseDetail',
            query : {id : item.id},
        })
      }
    },
    mounted: function () {
      this.getMyCollect()
    }
  }
</script>

<style scoped>
.collection-container{
  width:850px;
  float:right;
  background:#fff;
  border-radius: 6px;
  height: 800px;
  position: relative;
}
.collection-container ul{
  margin:0;
  padding:0;
}
.collection-container ul li{
  list-style-type: none;
  margin-left: 20px;
  margin-right: 20px;
  padding-top: 24px;
  padding-bottom: 24px;
  border-bottom: 1px solid #e5e5e5;
  height: 90px;
  overflow: hidden;
}
.collection-container ul li a{
  text-decoration: none;
}
.collection-cover{
  width: 160px;
  height: 90px;
  float: left;
  position: relative;
}
.collection-cover img{
  width: 160px;
  height: 90px;
  border-radius: 4px;
  position: absolute;
}
.collection-cover-text{
  width: 64px;
  height: 20px;
  background-color: rgba(0,0,0,0.6);
  position: absolute;
  z-index: 999;
  font-size: 12px;
  color: #fff;
  text-align: center;
  line-height: 20px;
  margin-top: 70px;
  border-radius: 0 4px 0 4px;
}
.collection-title{
  font-size: 18px;
  color: #252525;
  width: 640px;
  overflow: hidden;/*内容超出后隐藏*/
  text-overflow: ellipsis;/* 超出内容显示为省略号*/
  white-space: nowrap;/*文本不进行换行*/
}
.collection-right{
  float: left;
  margin-left: 10px;
}
.collection-icon{

}
.all-contentli-left{
  float: left;
  margin-top: 48px;
  margin-right: 24px;
}
.all-contentli-left img {
    width: 16px;
    height: 16px;
    float: left;
}
.all-contentli-left-text{
  font-size: 14px;
  line-height: 16px;
  color: #999;
  margin-left: 5px;
  float: left;
}
.task-pagination{
  text-align: center;
  position: absolute;
  bottom: 20px;
  width: 100%;
  left: 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/AccMyStudy/children/collection.vue